import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Container } from '@components/common/Container';
import { BodyText, Overline, PageSection, SectionTitle, TextLink } from '@components/common/Editorial';
const plans = ['smartCare', 'totalCareVip', 'personalCare360'];
export const PlanComparison = () => {
    const { t } = useTranslation();
    return (_jsx(PageSection, { "aria-labelledby": "plan-comparison-title", children: _jsxs(Container, { children: [_jsx(Overline, { children: t('planComparison.eyebrow') }), _jsx(SectionTitle, { id: "plan-comparison-title", children: t('planComparison.title') }), _jsx(BodyText, { children: t('planComparison.intro') }), _jsx(Cards, { children: plans.map((plan, index) => (_jsxs(Card, { "$featured": plan === 'personalCare360', children: [_jsxs("span", { "aria-hidden": "true", children: ["0", index + 1] }), _jsx("h3", { children: t(`planComparison.plans.${plan}.name`) }), _jsx("p", { children: t(`planComparison.plans.${plan}.summary`) }), _jsx("ul", { children: t(`planComparison.plans.${plan}.features`, { returnObjects: true }).map((feature) => (_jsx("li", { children: feature }, feature))) }), _jsx(TextLink, { to: `/products/${plan === 'smartCare' ? 'smart-care' : plan === 'totalCareVip' ? 'total-care-vip' : 'personal-care-360'}`, children: t('actions.viewDetails') })] }, plan))) })] }) }));
};
const Cards = styled.div `
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 2.5rem;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;
const Card = styled.article `
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 1.5rem;
  border: 1px solid
    ${({ theme, $featured }) => ($featured ? theme.colors.navy900 : theme.colors.line)};
  background: ${({ theme, $featured }) => ($featured ? theme.colors.mint50 : theme.colors.white)};
  > span {
    color: ${({ theme }) => theme.colors.muted};
    font-size: 0.75rem;
  }
  h3 {
    margin: 1rem 0 0;
    color: ${({ theme }) => theme.colors.navy900};
    font-size: 1.5rem;
    font-weight: 400;
  }
  p {
    color: ${({ theme }) => theme.colors.muted};
    line-height: 1.7;
  }
  ul {
    margin: 0.5rem 0 1.25rem;
    padding-left: 1.2rem;
  }
  li {
    margin: 0.55rem 0;
    line-height: 1.55;
  }
  a {
    margin-top: auto;
    align-self: flex-start;
  }
`;
